<template>
  <merus-data-table
    :headers="headers"
    :items="itens"
    :mostrar-inativos="mostrarInativos"
    :loading="loading"
    :default-multi-sort="defaultSort"
    :loading-text="$t('equipment.loading')"
    show-select
    item-key="id_equipamento"
    v-model="selecionados"
    cod-tabela="EQUIPAMENTOS"
    append-actions
    actions-i18n-key="system.labels.actions"
    @update:headers="headers = $event"
    @update:displayedItems="displayedItemsForExport = $event">
    <template v-slot:toolbar>
      <CadastroToolbar :title="titulo" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : itensVisiveis"
        :csv-title="titulo" :pdf-title="titulo" :pdf-headers="headers" :pdf-filename="titulo"
        :endpoint-upload-csv="permissoes.editar || permissoes.inserir ? '/api/v1.0/processacsvequipamentos/' : null"
        :csv-headers="headersCsv"
        :help-dialog-csv-fields="helpCsv"
        :help-dialog-csv-model="$tc('equipment.self', 2)"
        hide-search
        @saveBulk="$emit('saveBulk', $event)">
        <template v-slot:extension>
          <v-switch
            :input-value="mostrarInativos"
            :label="$t('crudVeiculos.showInactive')"
            class="ml-3 mr-4"
            hide-details
            @change="$emit('update:mostrarInativos', !!$event)"
          ></v-switch>
          <v-btn v-if="permissoes.editar" color="primary" dark small class="mb-2 mr-2"
            :disabled="!selecionados.length" @click="$emit('bulk-edit', selecionados)">
            <v-icon left small>mdi-pencil</v-icon>
            {{ $t('equipment.bulkEdit') }}
          </v-btn>
          <AjudaTooltip v-if="permissoes.editar" class="mb-2" :texto="$t('equipment.help.bulkEdit')" />
        </template>
        <template v-slot:add v-if="permissoes.inserir">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab @click="$emit('qr-download')">
                <v-icon>mdi-qrcode</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('equipment.qrcode.downloadTitle') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab @click="$emit('novo')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('equipment.registerEquipment') }}</span>
          </v-tooltip>
        </template>
      </CadastroToolbar>
    </template>

    <template v-slot:item.categoria_tipo_equipamento="{ item }">
      {{ categoriaDe(item.id_tipo_equipamento) }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" color="primary" :disabled="!permissoes.editar" @click="$emit('status', item)">mdi-progress-check</v-icon>
      <v-icon small class="mr-2" color="green" :disabled="!permissoes.editar" @click="$emit('editar', item)">mdi-pencil</v-icon>
      <v-icon small class="mr-2" color="red" :disabled="!permissoes.excluir" @click="$emit('excluir', item)">mdi-delete</v-icon>
    </template>

    <template v-slot:item.status_extenso="{ item }">
      <span :style="{ color: corTexto(item.status) }">
        <v-icon small :color="corComunicacao(item.status)" class="mr-1">{{ iconeComunicacao(item.status) }}</v-icon>
        {{ item.status_extenso }}
      </span>
    </template>
  </merus-data-table>
</template>

<script>
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';
import AjudaTooltip from './AjudaTooltip.vue';
import dispositivosFormatters from './Validadores/dispositivosFormatters';

/**
 * Cadastro de uma classe de equipamento (rastreadores, outros). O formulário, os diálogos e
 * as gravações ficam no CRUDEquipamentos: aqui só a tabela, que emite as ações.
 */
export default {
  name: 'TabelaEquipamentos',
  components: { MerusDataTable, CadastroToolbar, AjudaTooltip },
  mixins: [dispositivosFormatters],
  props: {
    titulo: { type: String, required: true },
    itens: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    token: { type: String, default: null },
    mostrarInativos: { type: Boolean, default: false },
    permissoes: { type: Object, default: () => ({}) },
    headersCsv: { type: Array, default: () => [] },
    helpCsv: { type: Array, default: () => [] },
    categoriaDe: { type: Function, default: () => '' },
  },
  data: () => ({
    headers: [],
    selecionados: [],
    displayedItemsForExport: null,
  }),
  computed: {
    defaultSort() {
      return [{ value: 'cod_equipamento', options: { text: this.$t('routs.increasing'), value: 1 } }];
    },
    itensVisiveis() {
      return this.mostrarInativos ? this.itens : this.itens.filter((e) => e.ativo == 1);
    },
  },
  methods: {
    limpaSelecao() {
      this.selecionados = [];
    },
    corTexto(status) {
      if (status == 1) return '#4caf50';
      if (status == 2) return '#f44336';
      return '#9e9e9e';
    },
  },
};
</script>
